import { doLogout } from 'actions/authAction'
import {
  BASE_URL,
} from './constant'

export const GET_DATA_LIST_PRICE_BRISTORE = 'GET_DATA_LIST_PRICE_BRISTORE'

const briPriceTray = (bool, val) => {
  return {
    type: GET_DATA_LIST_PRICE_BRISTORE,
    bool,
    val
  }
}

export const emptyDataBriPriceTray = () => {
  return {
    type: GET_DATA_LIST_PRICE_BRISTORE,
    bool:false,
    val:{data:[]}
  }
}

export function bristorePriceFetchPage(params, tokenx, land) {
  return (dispatch) => {
    if(land){
      dispatch(briPriceTray(true, {data:[]}))
    }else{
      dispatch(briPriceTray(true, []))
    }
    let token = tokenx || localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + 'mst_tarif_lcl_bristore/list', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      return response
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.status === 200){
        if(land){
          dispatch(briPriceTray(false, data))
        }else{
          dispatch(briPriceTray(false, data.data))
        }
      }else{
        if(land){
          dispatch(briPriceTray(false, {data:[]}))
        }else{
          dispatch(briPriceTray(false, []))
        }
        window.alert(data.message)
      }
    })
    .catch((err) => {
      if(land){
        dispatch(briPriceTray(false, {data:[]}))
      }else{
        dispatch(briPriceTray(false, []))
      }
      window.alert(err)
    })
  }
}
export function addBristorePrice(params, modal, dataFetch) {
  return (dispatch) => {
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + 'mst_tarif_lcl_bristore', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      return response
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.status === 200){
        dispatch(bristorePriceFetchPage(dataFetch))
        modal.handleModal('',{})
      }else{
        window.alert(data.message)
        modal.handleModal('',{})
      }
    })
    .catch((err) => {
      window.alert(err)
    })
  }
}

export function editBristorePrice(params, modal, dataFetch) {
  return (dispatch) => {
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + 'mst_tarif_lcl_bristore', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      return response
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.status === 200){
        dispatch(bristorePriceFetchPage(dataFetch))
        modal.handleModal('',{})
      }else{
        window.alert(data.message)
        modal.handleModal('',{})
      }
    })
    .catch((err) => {
      window.alert(err)
    })
  }
}

export function deleteBristorePrice(params, modal, dataFetch) {
  return (dispatch) => {
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if(token) {
      config = {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + 'mst_tarif_lcl_bristore', config)
    .then((response) => {
      if (response.status === 401) {
        dispatch(doLogout())
      }
      return response
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.status === 200){
        dispatch(bristorePriceFetchPage(dataFetch))
        modal.handleModal('',{})
      }else{
        window.alert(data.message)
        modal.handleModal('',{})
      }
    })
    .catch((err) => {
      window.alert(err)
    })
  }
}